import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { ihutActions, ihutSelectors } from '../../../../redux/slices/ihut.ts';
import { IhutActivity } from '../../../../api/ihut.ts';
import { isAfterCurrentDate } from '../../../../utils/date.ts';
import { logger } from '../../../../utils/logger.js';

const TestStepContinueButton = () => {
  const { t } = useTranslation('common');
  const activity = useAppSelector(
    ihutSelectors.selectSelectedActivity
  ) as IhutActivity;
  const dispatch = useAppDispatch();

  const handleContinueClick = () => {
    logger.clickStream('test_step_continue_button_click', {
      activity: activity.ihutProjectId,
      panelistId: localStorage.getItem('panelistId') || ''
    });
    dispatch(ihutActions.completeTestStep());
  };

  return (
    <Button
      variant="primary"
      disabled={
        !activity.testingCompleted ||
        !activity.survey ||
        activity.survey?.type !== 'FEEDBACK' ||
        isAfterCurrentDate(activity.survey.startTime)
      }
      size="small"
      UNSAFE_className={styles.continueBtn}
      onClick={handleContinueClick}
    >
      {t('continue')}
    </Button>
  );
};

export default TestStepContinueButton;
